<template>
  <dx-broker-offer-intro product="b-business" />
</template>

<script>
import DxBrokerOfferIntro from '~/domains/brokerOffer/components/DX-BrokerOfferIntro'

export default {
  name: 'BrokerOfferBBusinessIntro',
  components: {
    DxBrokerOfferIntro,
  },
  layout: 'non-sticky-nav',
  nuxtI18n: {
    paths: {
      de: '/partnerportal/unternehmensrechtsschutz/b-business/antragsstrecke/',
      fr: '/portailpartenaires/protection-juridique-entreprise/b-business/formulaire-de-demande/',
    },
  },
}
</script>
